import { atomFamily } from "jotai/utils";
import { atomWithStorage } from "jotai/utils";
import type { ComponentState, ComponentName } from "app/componentOptions";
import { SyncStorage } from "jotai/vanilla/utils/atomWithStorage";
import { atom } from "jotai";

// export const componentStorage: SyncStorage<ComponentState<any> | null> = {
//   getItem(key, initialValue) {
//     const raw = localStorage.getItem(key);
//     if (!raw) return initialValue;

//     try {
//       return JSON.parse(raw);
//     } catch {
//       return initialValue;
//     }
//   },

//   setItem(key, value) {
//     localStorage.setItem(key, JSON.stringify(value));
//   },

//   removeItem(key) {
//     localStorage.removeItem(key);
//   },
// };

// const getWindowAtom = atomFamily((id: string) =>
//   atomWithStorage<ComponentState<ComponentName> | null>(
//     id,
//     null,
//     componentStorage,
//     {
//       getOnInit: true,
//     }
//   )
// );

const getWindowAtom = atomFamily((id: string) =>
  atom<ComponentState<ComponentName> | null>(null)
);

export default getWindowAtom;
